const BACKEND_HOST = process.env["REACT_APP_BACKEND_HOST"];

let totalsPromise;

export const fetchTotals = (force = false) => {
    if (force || !totalsPromise) {
        totalsPromise = fetch(`${BACKEND_HOST}/upvotes/totals`)
            .then(res => res.json())
            .catch(err => {
                console.error("upvote totals failed", err);
                totalsPromise = null;
                return {};
            });
    }
    return totalsPromise;
};
